<era-panel>
  <div class="p-2">
    <ml-sk-spinner-3 [hidden]="certificates$ | async"></ml-sk-spinner-3>

    @if (certificates$ | async; as certificates) {
      @if (certificates?.length > 0) {
        @for (cert of certificates; track cert.commonName; let i = $index) {
          <era-pane class="mb-3">
            <h5 class="small-caps">Certificate {{ i + 1 }}</h5>
            <table class="table table-sm table-list mb-0">
              <thead>
                <tr>
                  <th colspan="2"
                      scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row"
                      title="Common name of the certificate">Common Name</th>
                  <td>{{ cert.commonName || 'N/A' }}</td>
                </tr>
                <tr>
                  <th scope="row"
                      title="Set to true if this is an identity certificate">Identity Certificate</th>
                  <td>
                    <ml-yes-no-icon [flag]="cert.isIdentity"></ml-yes-no-icon>
                  </td>
                </tr>
                @if (cert.data) {
                  <tr>
                    <th scope="row"
                        title="The certificate data in DER-encoded X.509 format">Data Length</th>
                    <td>{{ cert.data.length }} bytes</td>
                  </tr>
                }
              </tbody>
            </table>
          </era-pane>
        }
      }
      @if (certificates?.length === 0) {
        <div class="d-flex h-100 w-100 align-items-center justify-content-center">
          <p class="text-center text-muted p-4">
            The most recent query to the device returned no certificates.
            <br />
            <br />
            <small>Please refresh to retrieve the latest certificates from the device.</small>
          </p>
        </div>
      }
    }
  </div>
  <era-panel-footer>
    <div class="btn-toolbar p-1 bg-gray-100 border-top">
      <ml-mdm-command-spinner [commandProgress]="commandProgress$"
                              [small]="true"
                              [direction]="'right'"
                              [reverse]="true"
                              class="flex-grow-1 text-end">
        @if (udid$ | async; as udid) {
          <button type="button"
                  (click)="refresh()"
                  class="btn btn-outline-primary border-0">
            <fa-icon icon="sync"></fa-icon>
          </button>
        }
      </ml-mdm-command-spinner>
    </div>
  </era-panel-footer>
</era-panel>